<template>
  <div>
    <b-button type="reset" variant="danger" :disabled="isDisabled || spinners.isSaving"
              @click="onShowModal()">
      <b-spinner v-if="spinners.isSaving" type="grow" small/>
      {{ 'reject' | translate('global') }}
    </b-button>

    <Modal ref="reject-payment"
           @onClose="closeModal"
           :values="modalValues">
      <template slot="body">
        <div class="modal-body">
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>{{ 'comment' | translate('global') }}</label>
                <b-form-textarea type="text" v-model="comment"
                                 :placeholder=" 'reject_payment_comment_placeholder' | translate('global')"/>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </template>
      <template slot="footer">
        <b-button variant="danger" data-dismiss="modal" :disabled="spinners.isSaving" @click='onReject()'>
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ 'reject' | translate('global') }}
        </b-button>
        <b-button variant="secondary" @click="closeModal()" class="ml-2">{{ 'cancel' | translate('global') }}</b-button>
      </template>
    </Modal>
  </div>
</template>

<script>
import statuses from '@/store/statuses';
import Modal from '@/views/sharedComponents/Modal';
import { mapGetters, mapActions } from 'vuex';
import VuexTypes from '@/store/types/index';

const InvoiceTypes = VuexTypes.invoices;
export default {
  mounted() {},
  data() {
    return {
      spinners: {
        isSaving: false,
      },
      isDisabled: true,
      comment: '',
      modalValues: {
        id: 'reject-payment',
        title: this.$t('reject_payment', 'global'),
      },
    };
  },
  components: { Modal },
  computed: {
    ...mapGetters('Invoices', [
      'invoicePaymentReject',
      'invoiceUpdateData'
    ]),
  },
  watch: {
    invoicePaymentReject: {
      handler: function () {
        this.spinners.isSaving = false;
        if (this.invoicePaymentReject.status === statuses.LOADED) {
          this.closeModal();
        }
      },
      deep: true
    },
    invoiceUpdateData: {
      immediate: true,
      handler: function () {
        if (this.invoiceUpdateData.status === statuses.LOADED) {
          const data = this.invoiceUpdateData.data;
          const actions = data ? data['invoice']
            ? data['invoice']['actions'] : {}
            : {};
          this.isDisabled = !actions['decline_payment'];
        } else if (this.invoiceUpdateData.status === statuses.LOADING) {
          this.isDisabled = true;
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Invoices', [
      InvoiceTypes.INVOICE_PAYMENT_REJECT
    ]),
    onShowModal(data) {
      this.$refs['reject-payment'].show();
      this.deleteData = data;
    },
    closeModal() {
      this.$refs['reject-payment'].hide();
    },
    onReject() {
      this.spinners.isSaving = true;
      this.INVOICE_PAYMENT_REJECT({
        invoiceId: this.$route.params.id,
        rejectData: {
          comment: this.comment,
        }
      });
    },
  }
};

</script>
